import { render, staticRenderFns } from "./meetingypes.vue?vue&type=template&id=66453362"
import script from "./meetingypes.vue?vue&type=script&lang=js"
export * from "./meetingypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports